/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_After_5Inputs */

const en_landing_after_5 = /** @type {(inputs: Landing_After_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover letters that match the role and company`)
};

const de_landing_after_5 = /** @type {(inputs: Landing_After_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben, die zur Stelle und zum Unternehmen passen`)
};

const fr_landing_after_5 = /** @type {(inputs: Landing_After_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettres de motivation en phase avec le poste et l'entreprise`)
};

const es_landing_after_5 = /** @type {(inputs: Landing_After_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartas de presentación que encajan con el puesto y la empresa`)
};

const it_landing_after_5 = /** @type {(inputs: Landing_After_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettere di presentazione in linea con il ruolo e l'azienda`)
};

const nl_landing_after_5 = /** @type {(inputs: Landing_After_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivatiebrieven die passen bij de rol en het bedrijf`)
};

const pl_landing_after_5 = /** @type {(inputs: Landing_After_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listy motywacyjne dopasowane do roli i firmy`)
};

const fi_landing_after_5 = /** @type {(inputs: Landing_After_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saatekirjeet, jotka vastaavat tehtävää ja yritystä`)
};

const da_landing_after_5 = /** @type {(inputs: Landing_After_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgningsbreve der matcher rollen og virksomheden`)
};

const sv_landing_after_5 = /** @type {(inputs: Landing_After_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personliga brev som matchar rollen och företaget`)
};

/**
* | output |
* | --- |
* | "Cover letters that match the role and company" |
*
* @param {Landing_After_5Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_after_5 = /** @type {((inputs?: Landing_After_5Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_After_5Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_after_5(inputs)
	if (locale === "fr") return fr_landing_after_5(inputs)
	if (locale === "es") return es_landing_after_5(inputs)
	if (locale === "it") return it_landing_after_5(inputs)
	if (locale === "nl") return nl_landing_after_5(inputs)
	if (locale === "pl") return pl_landing_after_5(inputs)
	if (locale === "fi") return fi_landing_after_5(inputs)
	if (locale === "da") return da_landing_after_5(inputs)
	if (locale === "sv") return sv_landing_after_5(inputs)
	return en_landing_after_5(inputs)
});